import React, { useContext, useEffect, useState, useRef } from 'react';
import { ModalContext } from '../../components/contexts';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';
import { dbPost } from '../../apis/commonApi';
import { nlPost } from '../../apis/notLoginApi';
import { useNavigate, useLocation } from 'react-router-dom';

const AdminEntList = () => {
  useEffect(() => {
    document.title = '기업사용자 목록';
  }, []);

  const { modalService } = useContext(ModalContext);
  const [entList, setEntList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();

  const paginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return entList.slice(startIndex, startIndex + itemsPerPage);
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const getEntList = async () => {
    const url = '/adminUser/getEntList.do';
    dbPost(url)
      .then(response => {
        const entList = Array.isArray(response) ? response : [];
        setEntList(entList);
      })
      .catch(error => {});
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 1000); // 예시로 1초 후에 완료되는 비동기 작업
    });
  };

  useEffect(() => {
    const initialize = async () => {
      await getEntList();
    };
    initialize();
  }, []);

  const activation = async (paramOne, paramTwo) => {
    const url = '/adminUser/userActivate.do';
    const postParam = {
      entSn: paramOne,
      useYn: paramTwo === 'Y' ? 'Y' : 'N',
      memberType: 'ent',
    };

    try {
      const response = await dbPost(url, postParam);
      await getEntList();
      if (paramTwo === 'Y') {
        await modalService.successAlert('사용자를 비활성화했습니다.');
      } else if (paramTwo === 'N') {
        await modalService.successAlert('사용자를 활성화했습니다.');
      }
    } catch (error) {}
  };

  const entInfo = value => {
    const moveParam = {
      entId: value,
      userType: 'E',
    };

    navigate('/member/userInfo/adminEntInfo', {
      state: moveParam,
      replace: true,
    });
  };

  const newMemberEnt = () => {
    navigate('/member/entJoinBRNO');
  };

  const renewPassword = (valOne, valTwo, valThr) => {
    const url = '/member/recoverPassword.do';
    const postParam = {
      id: valOne,
      name: valTwo,
      email: valThr,
      memberType: 'ent',
    };
    if (postParam.email === '' || postParam.email === null) {
      modalService.errorAlert('등록된 이메일이 없습니다.', () => {});
      return;
    }
    nlPost(url, postParam)
      .then(response => {
        modalService.successAlert('임시 비밀번호를 전송했습니다.', () => {});
      })
      .catch(error => {});
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">기업사용자관리</h2>
      </div>
      <div className="tbl-wrap">
        <h3 className="block-tit">기업사용자 목록</h3>
        <div className="tbl-scroll-box">
          <table className="tbl col data">
            <thead>
              <tr>
                <th scope="col">사용자 아이디</th>
                <th scope="col">기업명</th>
                <th scope="col">대표자</th>
                <th scope="col">주소</th>
                <th scope="col">전화번호</th>
                <th scope="col">팩스번호</th>
                <th scope="col">담당자</th>
                <th scope="col">가입일자</th>
                <th scope="col">계정 활성화</th>
                <th scope="col">패스워드 초기화</th>
              </tr>
            </thead>
            <tbody>
              {/*시작*/}
              {paginatedData().map((entList, index) => (
                <tr key={index}>
                  <td>
                    <a
                      className="btn btn-txt underline"
                      onClick={e => {
                        e.preventDefault();
                        entInfo(entList.entId);
                      }}
                    >
                      {entList.entId}
                    </a>
                  </td>
                  <td>
                    <strong>{entList.entNm || '-'}</strong>
                  </td>
                  <td>{entList.entRprsv || '-'}</td>
                  <td>{entList.entAddr || '-'}</td>
                  <td>{entList.entTelno || '-'}</td>
                  <td>{entList.entFxno || '-'}</td>
                  <td>{entList.picNm || '-'}</td>
                  <td>{entList.regDt || '-'}</td>
                  <td>
                    {entList.useYn == 'Y' ? (
                      <a
                        className="btn sm secondary"
                        onClick={() => {
                          activation(entList.entSn, entList.useYn);
                        }}
                      >
                        비활성화
                      </a>
                    ) : (
                      <a
                        className="btn sm secondary"
                        onClick={() => {
                          activation(entList.entSn, entList.useYn);
                        }}
                      >
                        활성화
                      </a>
                    )}
                  </td>
                  <td>
                    <a
                      className="btn sm tertiary"
                      onClick={() => {
                        renewPassword(
                          entList.entId,
                          entList.entNm,
                          entList.picEml
                        );
                      }}
                    >
                      초기화
                    </a>
                  </td>
                </tr>
              ))}
              {/*껕*/}
            </tbody>
          </table>
        </div>
      </div>
      <GbitTablePaging
        totalItems={entList.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
      <div className="page-btn-wrap">
        <button
          type="button"
          className="btn xlg primary"
          onClick={newMemberEnt}
        >
          신규등록
        </button>
      </div>
    </>
  );
};

export default AdminEntList;
